module.exports = __webpack_public_path__ + "img/messenger.8553b89d.svg";